module.exports = __webpack_public_path__ + "static/media/cmbanner.a6c74ca9.jpg";